import { useMutation, useQueryClient } from '@tanstack/react-query';

import { setCardRules } from '@/react-query/services/card-rules';

import { CardRule, CardType } from '@generated-types';

interface SetCardRulesRequest {
    cardType: CardType;
    cardId: string;
    cardRules: CardRule;
}

export const useSetCardRules = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['setCardRules'],
        mutationFn: ({ cardType, cardId, cardRules }: SetCardRulesRequest) => setCardRules(cardType, cardId, cardRules),
        onMutate: async ({ cardType, cardId, cardRules }) => {
            const queryKey = ['cardRule', cardType, cardId];
            await queryClient.cancelQueries({
                queryKey,
            });

            // Snapshot the previous value
            const snapshot = queryClient.getQueryData(queryKey);

            // Optimistically update to the new value
            queryClient.setQueryData(queryKey, cardRules);

            // Return a context object with the snapshotted value
            return { snapshot };
        },
        onError: (err, _, context) => {
            queryClient.setQueryData(['cardRule'], context?.snapshot);
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: ['cardRule'] });
        },
    });
};
